<template>
  <div v-if="latestWidget && latestWidget.category" :class="['latest-posts']">
    <PostList :size="latestWidget.numberOfItems" :category="latestWidget.category.id" />
  </div>    
</template>

<script>

import gql from 'graphql-tag'

import PostList from 'components/PostList.vue'

export default {
  name: 'LatestPostsWidget',
  components: {
    PostList
  },
  data() {
    return {
      latestWidget: {}
    }
  },
  props: [
    'id',
    'context'
  ],
  apollo: {
    latestWidget: {
      query: gql`query LatestWidget ($id: ItemId) {
        latestWidget(filter: {id: {eq: $id}}) {
          title
          numberOfItems
          category { id }
        }
      }`,
      variables() {
        return {
          id: this.id
        }
      }
    }
  }
}
</script>

<style scoped lang="less">

</style>
